<template>
  <BootstrapModal
    class="CustomerInformation"
    :disable-button="true"
    :remove-padding="true"

    v-on="$listeners"
  >
    <div class="p-2 d-flex content-wrapper" :class="{'disable-ske': !loading}">
      <div class="flex-shrink-0">
        <dl class="d-flex px-2">
          <div class="d-flex flex-column">
            <dt class="ske">Voornaam</dt>
            <dd class="ske">{{ item.firstName }}</dd>
          </div>
          <div class="d-flex flex-column ml-4">
            <dt class="ske">Achternaam</dt>
            <dd class="ske">{{ item.lastName }}</dd>
          </div>
          <div class="d-flex flex-column ml-4">
            <dt class="ske">Email</dt>
            <dd class="ske">{{ item.email }}</dd>
          </div>
        </dl>

        <CustomerWholesaleToggle
          v-if="!loading && isWholesale"

          :customer_group="item.customer_group"
          :magento_id="item.magento_id"
          :callback="callback"
        />

        <hr>

        <div class="d-flex flex-column">
          <h4 class="flex-shrink-0">
            <span class="ske">
              Evenementen
            </span>
          </h4>

          <ul v-if="loading">
            <li v-for="(num, index) in 10" class="mt-1" :key="index">
              <span class="ske">
                {{ num % 2 === 0 ? "sahto asht asht sht" : " asht ashti nashtnieo asthn " }}
              </span>
            </li>
          </ul>
          <div v-else-if="!events.length" class="flex-grow-1 empty-state-wrapper d-flex justify-content-center align-items-center">
            <EmptyStatePlaceholder
              title="Deze klant heeft nog geen evenementen"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
                  <path d="M1.5,2.5a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h11a1,1,0,0,0,1-1v-9a1,1,0,0,0-1-1h-2" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                  <line x1="3.5" y1="0.5" x2="3.5" y2="4.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                  <line x1="10.5" y1="0.5" x2="10.5" y2="4.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                  <line x1="3.5" y1="2.5" x2="8.5" y2="2.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                  <line x1="8.77" y1="9.77" x2="5.23" y2="6.23" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                  <line x1="8.77" y1="6.23" x2="5.23" y2="9.77" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                </g></g>
              </svg>
            </EmptyStatePlaceholder>
          </div>
        </div>
      </div>
      <div class="orders flex-grow-1 px-2 d-flex flex-column">
        <h4 class="flex-shrink-0">
          <span class="ske">Bestellingen</span>
        </h4>

        <div v-if="loading">
          <OrderItem v-for="item in orderPlacehoder" :key="item.uid"
            v-bind="item"
          />
        </div>
        <div v-else-if="!orders.length" class="d-flex justify-content-center align-items-center flex-grow-1">
          <EmptyStatePlaceholder
            title="Deze klant heeft nog geen evenementen"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
                <path d="M5.5,5.5h-3a2,2,0,0,0-2,2v4H2" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                <path d="M12.5,11.5h1v-7a1,1,0,0,0-1-1h-6a1,1,0,0,0-1,1v5.68" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                <line x1="6" y1="11.5" x2="8.5" y2="11.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                <circle cx="4" cy="11.5" r="2" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></circle>
                <circle cx="10.5" cy="11.5" r="2" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></circle>
              </g></g>
            </svg>
          </EmptyStatePlaceholder>
        </div>
        <ul v-else>
          <OrderItem v-for="item in orders" :key="item.uid"
            v-bind="item"
          />
        </ul>
      </div>
    </div>

    <template #title>
      Klantgegevens
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import EmptyStatePlaceholder from "../../EmptyStatePlaceholder.vue"
import OrderItem from "./CustomerInformation/OrderItem.vue"
import FormToggleSwitch from "@/components/Inputs/FormToggleSwitch";
import CustomerWholesaleToggle from "@/components/CustomerWholesaleToggle";

const orderPlaceholder = {
  state: "SHIPPED",
  orderAmount: 19.97,
  orderNumber: "1299300933",
  orderDate: "2021-12-05T19:00:41.000Z",
  site: "bol.com bol.com",
}

export default {
  components: {
    FormToggleSwitch,
    BootstrapModal,
    EmptyStatePlaceholder,
    OrderItem,
    CustomerWholesaleToggle,
  },
  props: {
    item: Object,
    callback: Function,
    isWholesale: Boolean,
  },
  created() {
    this.fetchEvents()
  },
  data() {
    return {
      loading: true,
      wholesaleActive: (this.item.customer_group || "").toLowerCase() === "wholesale",

      orderPlacehoder: [
        orderPlaceholder,
        orderPlaceholder,
        orderPlaceholder,
      ],

      orders: [],
      events: [],
      orderImages: [],
    }
  },
  methods: {
    async fetchEvents() {
      this.loading = true

      const [orders, events] = await Promise.all([
        (async () => (await this.axios.get(`/api/customers/${this.item.uid}/orders`)).data.results)(),
        /*(async () => (await this.axios.get(`/api/customers/${this.item.uid}/events`)).data.results)(),*/
      ])

      const orderImages = {}
      orders.forEach(async ({sku}) => {
        const results = (await this.axios.get(`/api/products/${sku}/files`)).data.results
        if (results && results[0]) {
          orderImages[sku] = results[0].url
        }
      })
      this.orderImages = orderImages

      // this.orders = orders.map(item => ({...item, src: orderImages[item.sku]}))
      this.orders = orders
      // this.events = events

      this.loading = false
    },
  },
}

</script>

<style scoped>

.CustomerInformation {
  flex-basis: 1200px;
}

.empty-state-wrapper {
  margin: 50px 0px;
}

.content-wrapper {
  min-height: 500px;
}

.orders {
  border-left: 1px solid #EFEFF0;
}

h4 {
  margin: 0;
}

li {
  list-style: none;
}

br {
  border: 1px solid #EFEFF0;
}

@media (max-width: 1200px) {
  .content-wrapper {
    display: block !important;
  }

  .orders {
    padding: 0px !important;
    padding-top: 14px !important;
    border-left: none;
    border-top: 1px solid #EFEFF0;
  }
}

</style>
